import { Component, OnInit } from "@angular/core";
import { LoaderService, Message } from "@stdoutsrl/design-kit";
import { PlanService } from "../../service/plan.service";

@Component({
  selector: "app-plans-registration",
  templateUrl: "./plans-registration.component.html",
  styles: [],
  standalone: false,
})
export class PlansRegistrationComponent implements OnInit {
  constructor(
    private loader: LoaderService,
    private message: Message,
    private planService: PlanService
  ) {}
  plans: any[] = [];
  selectedPlan = -1;
  paymentUrl = "";
  showTypePlan = "A";
  ngOnInit(): void {
    this.getPlans();
  }
  getPlans() {
    this.loader.on();
    this.planService.getPlans().subscribe({
      next: (value: any) => {
        this.plans = value;
        this.loader.off(true);
      },
      error: () => {
        this.loader.off(true);
      },
    });
  }

  changeTypePlan(event: any) {
    this.showTypePlan = event.value;
  }

  subscribeToPlan(id: number) {
    this.loader.on();
    this.planService.subscribeToPlan(id).subscribe({
      next: (value: any) => {
        this.paymentUrl = value.paymentUrl;
        this.loader.off(true);
      },
      error: (value) => {
        this.loader.off(true);
        window.location.replace("login");
      },
    });
  }

  goToPay() {
    window.location.replace(this.paymentUrl);
  }
}
